export const errorHandler = (error: any) => {
  if (error.response.data.message) {
    errorAlert('실패', error.response.data.message);
  } else {
    errorAlert('실패', '알 수 없는 오류가 발생했습니다.');
  }
};
